/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('restApiSourceEditor', [
  '$rootScope',

  function ($rootScope) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./rest-api-source-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.showCodemirror = false;
          $scope.headersValid = true;

          $scope.bodyDataOptions = {
            lineWrapping: true,
            lineNumbers: true,
            theme: 'twilight',
            mode: 'text/json',
            placeholder:
              '{\n  "type": "transaction"\n  "start_at": "2019-10-01"\n}\nor\ntype=transaction&start_at=2019-10-01',
          };

          $scope.paginationSchemeOptions = [
            {
              value: 'auto',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.auto',
              translate: true,
            },
            {
              value: 'jira',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.jira',
              translate: true,
            },
            {
              value: 'magento',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.magento',
              translate: true,
            },
            {
              value: 'linkheaders',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.linkheaders',
              translate: true,
            },
            {
              value: 'bigcommercev2',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.bigcommercev2',
              translate: true,
            },
            {
              value: 'elasticsearch',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.elasticsearch',
              translate: true,
            },
            {
              value: 'elasticsearchscroll',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.elasticsearchscroll',
              translate: true,
            },
            {
              value: 'appsyncdynamodb',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.appsyncdynamodb',
              translate: true,
            },
            {
              value: 'facebookbusinessdiscovery',
              text: 'rest-api-source-editor.form.selects.pagination_scheme.options.facebookbusinessdiscovery',
              translate: true,
            },
          ];

          $scope.onPaginationSchemeChange = (paginationScheme) => {
            $scope.component.pagination_scheme = paginationScheme;
          };

          $scope.onHeadersChange = (records) => {
            $scope.component.headers = records;
          };

          $scope.onHeadersValidityChange = (isValid) => {
            $scope.headersValid = isValid;
          };
        },
      ],
    };
  },
]);
